import React from "react";
import * as S from "./styles";
export var Success = function Success(e) {
  return React.createElement(S.BaseSVG, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "17",
    height: "16",
    fill: "none",
    viewBox: "0 0 17 16"
  }, e), React.createElement("path", {
    stroke: "#1E824C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3",
    d: "M2 8.333l4.246 5 8.42-8.666"
  }));
};